if(!customElements.get('countdown-timer')) {
  class CountdownTimer extends HTMLElement {
    constructor() {
      super();
      this.updateInterval = null;
    }

    connectedCallback() {
      this.updateTime();
      this.updateInterval = setInterval(() => {
        this.updateTime();
      }, 1000);  // Update every second
    }

    disconnectedCallback() {
      clearInterval(this.updateInterval);
    }

    updateTime() {
      const timestamp = parseInt(this.getAttribute('data-timestamp'), 10);
      const now = Math.floor(Date.now() / 1000);
      const remainingSeconds = timestamp - now;
      if (remainingSeconds <= 0) {
        this.textContent = 'NOW';
        clearInterval(this.updateInterval);
        return;
      }
      const days = Math.floor(remainingSeconds / 86400);
      const hours = Math.floor((remainingSeconds % 86400) / 3600);
      const minutes = Math.floor(((remainingSeconds % 86400) % 3600) / 60);

      let timeString = '';
      if (days > 0) timeString += `${days} Days`;
      if (hours > 0) timeString += ` ${hours} Hours`;
      if (minutes > 0) timeString += ` ${minutes} Minutes`;

      this.textContent = timeString.trim();
    }
  }

  customElements.define('countdown-timer', CountdownTimer);
}

